/**
 * Location Filters
 *
 * Server-side location matching. A single combined `location_search` filter
 * accepts a comma-separated list; each token is classified server-side by
 * shape (postcode / sector / outcode / town / county / region) and matched
 * with OR semantics across all populated buckets. Available to all tiers.
 *
 * Backend contract: routed to the `location=` query param on
 * /properties/search. See backend propertySearchService.classifyLocationTokens.
 */

import { Filter } from '../../types/filters';

export const locationFilters: Filter[] = [
  {
    id: 'location_search',
    name: 'Location',
    description: 'Filter by postcode, postcode sector, outcode, town, county, or region',
    category: 'location',
    type: 'location_search',
    minTier: 'STARTER',
    premiumFeature: false,
    popularityRank: 1,
    dataPath: 'teaser.postcodeSector',
    version: '1.0.0',
    enabled: true,
    defaultValue: '',
    config: {
      placeholder: 'e.g. Manchester, Kent, SW1A 1AA',
      debounceMs: 350,
      helperText: 'Separate multiple values with commas. Matches any (OR).',
    },
  },
];
